import React, { createContext, useContext, useState } from 'react';

export type CheckoutButtonState = 'initial' | 'loading' | 'disabled';

interface CartCheckoutActionsContextValue {
  newCustomerCheckoutButtonState: CheckoutButtonState;
  signInAndCheckoutButtonState: CheckoutButtonState;
  existingCustomerCheckoutButtonState: CheckoutButtonState;

  setNewCustomerCheckoutButtonState: (
    newCheckoutButtonState: CheckoutButtonState,
  ) => void;
  setSignInAndCheckoutButtonState: (
    newCheckoutButtonState: CheckoutButtonState,
  ) => void;
  setExistingCustomerCheckoutButtonState: (
    newCheckoutButtonState: CheckoutButtonState,
  ) => void;
}
const CartCheckoutActionsContext =
  createContext<CartCheckoutActionsContextValue | null>(null);

export default function CartCheckoutActionsProvider({
  children,
}: React.PropsWithChildren<{}>) {
  const [newCustomerCheckoutButtonState, setNewCustomerCheckoutButtonState] =
    useState<CheckoutButtonState>('initial');
  const [signInAndCheckoutButtonState, setSignInAndCheckoutButtonState] =
    useState<CheckoutButtonState>('initial');
  const [
    existingCustomerCheckoutButtonState,
    setExistingCustomerCheckoutButtonState,
  ] = useState<CheckoutButtonState>('initial');

  const value = {
    newCustomerCheckoutButtonState,
    signInAndCheckoutButtonState,
    existingCustomerCheckoutButtonState,

    setNewCustomerCheckoutButtonState,
    setSignInAndCheckoutButtonState,
    setExistingCustomerCheckoutButtonState,
  };

  return (
    <CartCheckoutActionsContext.Provider value={value}>
      {children}
    </CartCheckoutActionsContext.Provider>
  );
}

export function useCartCheckoutActions() {
  const context = useContext(CartCheckoutActionsContext);
  if (!context) {
    throw new Error(
      'useCartCheckoutActions should be used inside CartCheckoutActionsProvider',
    );
  }
  return context;
}
